import React, { useRef } from 'react'
import { locale } from '../../../../ui/locale'
import Button from '@mui/material/Button'
import AddIcon from '@mui/icons-material/Add';
// import EditFieldListItem from './EditFieldListItem';
import IconButton from '@mui/material/IconButton';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import ArrowUpwardIcon from '@mui/icons-material/ArrowUpward'
import ArrowDownwardIcon from '@mui/icons-material/ArrowDownward'
import useOutsideClick from '../../../../hooks/useOutsideClick'
import EditFieldListItem from './EditFieldListItem';
import { Box } from '@mui/material';
import { Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material'

// import {CatalogOnDrawName} from './CatalogOnDrawName'


export default function EditFieldList(p: any) {

    const wrapperRef = useRef(null);
    useOutsideClick(wrapperRef, p.onOutsideClick)

    const viewList = p.list
    .map((item: any, index: number) => ({filter: item.filter, value: item.value, index: index}))
    .sort((a: any, b: any) => {
        if (!p.sorting) return 0
        if (a.filter === '') return 1
        if (b.filter === '') return -1
        if (a.filter.toLowerCase() < b.filter.toLowerCase()) {
            return -1
        } 
        return 1
    })

    return(
        <div>
        {viewList.length === 0
        ? <Box sx={{padding: 2}}>
                {locale('collections.fields.fieldsListValuesEmpty')}
        </Box>
        : <TableContainer>
            <Table>
            <TableBody>

            {viewList
            .map((item: any) => (
            <TableRow 
                hover={p.toEditListIndex !== item.index}
                key={item.index} 
                ref={p.toEditListIndex === item.index ? wrapperRef : null}
            >
                {p.toEditListIndex === item.index
                ? <TableCell sx={{padding: 1}} >
                    <EditFieldListItem 
                        filter={item.filter}
                        value={item.value}
                        onCancelEditListItem={p.onCancelEditListItem}
                        onSaveListItem={p.onSaveListItem}
                    />
                </TableCell>
                : <TableCell sx={{cursor: 'pointer'}} onClick={event => p.onEditListItem(item.index)} >            
                    <strong>{item.filter}</strong>
                    <div><small>{item.value}</small></div>
                </TableCell>
                }            
            <TableCell width='70px' sx={{padding: 1, verticalAlign: 'top'}}>
                {p.toEditListIndex === item.index && !p.sorting
                ?<div>
                    <IconButton 
                        size="small" 
                        color="primary"
                        disabled={item.index === 0}
                        onClick={() => p.onMoveItem(item.index, false)}
                    >
                        <ArrowUpwardIcon />
                    </IconButton>
                    <IconButton 
                        size="small" 
                        color="primary"
                        disabled={item.index === p.list.length - 1}
                        onClick={() => p.onMoveItem(item.index, true)}
                    >
                        <ArrowDownwardIcon />
                    </IconButton>
                </div>
                : null
                }
            </TableCell>
            <TableCell width='30px' sx={{padding: 1, verticalAlign: 'top'}}>
                {p.toEditListIndex === item.index
                ?
                <IconButton 
                    size="small" 
                    // disabled={formState.loading}
                    color="secondary"
                    onClick={() => p.onDeleteListItem(item.index)}
                >
                    <DeleteOutlineIcon />
                </IconButton>
                : null
                }
            </TableCell> 
           
            </TableRow>
            ))}
            </TableBody>
            </Table>
        </TableContainer>
        }
        <Button 
            id="addListItem" 
            size="medium"
            startIcon={<AddIcon />}
            color="primary"
            onClick={p.addListItem}
            disabled={p.toEditListIndex >= 0}
        >
            {locale('collections.fields.fieldsListAdd')}
        </Button>
        </div>
    )
}